var map = {
	"./1.jpg": 6078,
	"./10.jpg": 1924,
	"./11.jpg": 5521,
	"./12.jpg": 9734,
	"./2.jpg": 7577,
	"./3.jpg": 9788,
	"./4.jpg": 23,
	"./5.jpg": 1738,
	"./6.jpg": 8965,
	"./7.jpg": 1352,
	"./8.jpg": 1091,
	"./9.jpg": 6326
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 208;